/**
 * MapFirestoreService - Handles Firestore CRUD for map_markers collection.
 */
import {
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where
} from '../../firebase-config';
import { serverTimestamp } from 'firebase/firestore';
import { firestore } from '../../firebase-config';

class MapFirestoreService {
  constructor(collectionName = 'map_markers') {
    this.collectionName = collectionName;
  }

  setCollection(collectionName) {
    this.collectionName = collectionName;
  }

  getCollectionRef() {
    return collection(firestore, this.collectionName);
  }

  async createMarker(data) {
    if (!data.title || !data.lat || !data.lng) {
      throw new Error('Title, latitude, and longitude are required');
    }
    const docData = { ...data, createdAt: serverTimestamp(), updatedAt: serverTimestamp() };
    const docRef = await addDoc(this.getCollectionRef(), docData);
    return docRef.id;
  }

  async updateMarker(id, data) {
    const docRef = doc(firestore, this.collectionName, id);
    await updateDoc(docRef, { ...data, updatedAt: serverTimestamp() });
  }

  async deleteMarker(id) {
    const docRef = doc(firestore, this.collectionName, id);
    await deleteDoc(docRef);
  }

  async getMarker(id) {
    const docRef = doc(firestore, this.collectionName, id);
    const snapshot = await getDoc(docRef);
    if (!snapshot.exists()) return null;
    return { id: snapshot.id, ...snapshot.data() };
  }

  async getAllMarkers() {
    const snapshot = await getDocs(this.getCollectionRef());
    return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  }

  async queryByCategory(category) {
    const q = query(this.getCollectionRef(), where('category', '==', category));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  }

  async queryByTag(tag) {
    const q = query(this.getCollectionRef(), where('tags', 'array-contains', tag));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  }
}

export default MapFirestoreService;
